import React from 'react'

import { 
    Card, 
    Row 
} from 'antd'


class UserDetails extends React.Component{

    render(){
        
        return(
            <div>
                {this.renderUserDetails(this.props.userdetails)}
            </div>
        )
    }

    renderUserDetails=(details)=>{

        var header = ''

        if(details.companyName){
            header=`Customer Journey | ${details.companyName}`
        }
        else{
            header="Customer Journey"
        }

        return(
            
            <Card
                title={header}>
                <Row>
                        <strong>{details.companyName? details.companyName: "No Company"}</strong><br/>
                        <br/>
                        {details.name? details.name: "No name"}<br/>
                        {details.hp? details.hp: "No hp"}<br/><br/>
                        <strong>Address</strong><br/>
                        {details.address? details.address: "No address"}<br/>
                        {details.postalCode? details.postalCode: "No postal"}
                </Row>
            </Card>
        )

    }

}

export default UserDetails


// WEBPACK FOOTER //
// ./src/components/customer-journey/user-details.js